<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Валюты и курсы</h5>
      </div>
      <div class="card-body">
        <table class="table table-sm table-hover">
          <thead>
          <tr>
            <th>Код</th>
            <th>Количество в 1 EUR</th>
            <th>Обновлено</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="currency in rates">
            <td>{{currency.currency}} ({{currency.id}})</td>
            <td><input @change="updateRate(currency)" type="number" v-model="currency.display_rate" :disabled="currency.id == 28" class="form-control"></td>
            <td>{{currency.updated_at}}</td>
          </tr>
          </tbody>
        </table>
        <div class="text-right">
          <vue-ladda @click="updateRates" button-class="btn btn-sm btn-success"
                     data-style="zoom-in"
                     :loading="loading">Сохранить
          </vue-ladda>
        </div>
      </div>
    </div>

    <div class="card" v-if="records && rates && Object.keys(rates).length">
      <div class="card-header">
        <h5 class="pull-left">История изменений курсов</h5>
        <div class="pull-right">
          <select @change="getHistoryRates(1)" v-model="filter.currency_id" class="form-control">
            <option value="0">Все валюты</option>
            <option v-for="curr in rates" :value="curr.id">{{curr.currency}}</option>
          </select>
        </div>
      </div>
      <div class="card-body">

        <div>
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Дата</th>
                <th>Валюта</th>
                <th>Курс</th>
                <th>Добавлен</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="record in records">
                <td>{{record.date}}</td>
                <td>{{rates[record.currency_id].currency}}</td>
                <td>{{Math.round(1/record.rate*1000) / 1000}}</td>
                <td>{{record.manual ? 'Добавлен вручную' : 'Покупка валюты'}}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="getHistoryRates"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import api from '@/api'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'
  import moment from 'moment'
  import Paginate from 'vuejs-paginate'
  import store from "../../../store";

  export default {
    title: 'Курсы валют',
    components: {
      VueLadda,
      Paginate,
    },
    data() {
      return {
        rates: {},
        paginator: null,
        records: null,
        loading: false,
        currencies: {},
        filter: {
          currency_id: 0
        }
      }
    },
    computed: {
      $AllCurrencies() {
        return this.$store.getters['platform/currencies']
      },
    },
    async mounted() {
      this.getNewRates();
      await this.getHistoryRates();
    },
    methods: {
      updateRate(c) {
        this.rates[c.id].rate = 1 / c.display_rate;
      },
      getNewRates() {
        let rates = {};
        Object.keys(this.$AllCurrencies).forEach((index) => {
          rates[this.$AllCurrencies[index].id] = {...this.$AllCurrencies[index]};
          rates[this.$AllCurrencies[index].id].display_rate = Math.round(1 / this.$AllCurrencies[index].rate * 1000) / 1000;
        });
        this.rates = rates;
      },
      async updateRates() {
        let changes = [];
        Object.keys(this.$AllCurrencies).forEach((index) => {
          if (+this.rates[this.$AllCurrencies[index].id].rate !== +this.$AllCurrencies[index].rate) {
            changes.push(this.rates[this.$AllCurrencies[index].id]);
          }
        })
        if (!changes.length) return;
        this.loading = true;
        const {data} = await api.post('/settings/updateRate', {
          rates: changes
        });
        if (!data.success){
          toastr['warning'](data.message || 'Ошибка на сервере', 'Ошибка');
        }else{
          toastr['success'](data.message || 'Сохранено', 'Успешно');
          store.dispatch('platform/setCurrencies', data.currencies);
          this.getNewRates();
          await this.getHistoryRates(1);
        }
        this.loading = false;
      },
      async getHistoryRates(page = 1){
        this.records = null;
        this.paginator = null;
        let {data: r_data} = await api.index('/settings/historyRates?page=' + page + '&curr_id='+this.filter.currency_id)
        if (r_data.success) {
          const {data, ...pagination} = r_data.records
          this.paginator = pagination
          this.records = data
        }else{
          toastr['warning'](r_data.message || 'Ошибка на сервере', 'Ошибка');
        }
      }
    }
  }

</script>
